// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Vh","zenCrossSiteLabel":"Wh","vrsnlCrossSiteLabel":"Xh"};